// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'

const ChevronBackground = ({
  backgroundColor, bootstrapClasses, children, className, direction,
}) => (
  <div className={className ? `${className} position-relative` : 'position-relative'}>
    <div className={`bg--${backgroundColor}-chev ${direction}`} />
    <div className={`position-relative ${bootstrapClasses ? ` ${bootstrapClasses}` : ''}`}>
      {children}
    </div>
  </div>
)

ChevronBackground.propTypes = {
  backgroundColor: PropTypes.oneOf(['blue', 'green', 'yellow', 'red', 'gray']).isRequired,
  bootstrapClasses: PropTypes.string,
  className: PropTypes.string,
  direction: PropTypes.oneOf(['north', 'south', 'east', 'west']).isRequired,
}

ChevronBackground.defaultProps = {
  className: '',
}

export default ChevronBackground
